

exports.__esModule = true;
exports.$xoSidebarCurrencyConversionPageComponent = undefined;

var _uiRouter = require('uiRouter');

var _squid = require('squid');

var _angular = require('angular');

require('xo-page-components/src/aside-header/directive');

require('xo-wallet-components/src/currency-conversion/directive');

var _template = require('./template');

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var $xoSidebarCurrencyConversionPageComponent = exports.$xoSidebarCurrencyConversionPageComponent = _squid.$Component.extend('$xoSidebarCurrencyConversionPageComponent', {
    tag: 'xo-sidebar-currency-conversion-page',
    template: _template2['default'],
    controller: ['$scope', function ($scope) {
        $scope.token = _angular.$rootScope.token;
        $scope.onComplete = function () {
            _uiRouter.$state.go('checkout.review');
        };
        $scope.$emit('populated');
    }]
});

angular.value("$xoSidebarCurrencyConversionPageComponent", $xoSidebarCurrencyConversionPageComponent);
_uiRouter.$state;

_squid.$Component;

_angular.$rootScope;


//////////////////
// WEBPACK FOOTER
// ./pages/xo-sidebar-currency-conversion/directive.js
// module id = ./pages/xo-sidebar-currency-conversion/directive.js
// module chunks = 0